module.exports = __webpack_public_path__ + "img/4-congratulations.385bbf57.jpg";